import request from '@/utils/request'
// 专题页
export function getTopicPage(params) {
    return new Promise((resolve, reject) => {
      request.get('/adks-app/pc/apiv1/topic/page', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  }

export function getHomePageTopic(params) {
    return new Promise((resolve, reject) => {
      request.get('/adks-app/pc/apiv1/topic/getHomePageTopic', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  }
  export function gettTopicDetail(params) {
    return new Promise((resolve, reject) => {
      request.get('/adks-app/pc/apiv1/topic/detail', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  }

  